:host {
    display: block;
}

:host > es-button,
    :host > es-button-link {
        --current-color: var(--color-shade-60);
        --spacing: 6px;
        --height: 32px;
        --border-radius: 50%;
    }

:host > es-button[disabled], :host > es-button-link[disabled] {
            --current-color: var(--color-shade-50);
        }

:host([dropdown-item]) > es-button,
    :host([dropdown-item]) > es-button-link {
        --border-radius: 0;
        --align-inner: flex-start;
        --height: 46px;
        --spacing: 12px;
        width: 100%;
    }

:host([dropdown-item]) > es-button::part(button),
        :host([dropdown-item]) > es-button-link::part(button),
        :host([dropdown-item]) > es-button::part(link),
        :host([dropdown-item]) > es-button-link::part(link) {
            padding-right: calc(var(--spacing) * 2);
        }

:host([dropdown-item]) > es-button:hover, :host([dropdown-item]) > es-button-link:hover {
            --background-color: var(--color-shade-20);
        }

:host([dropdown-item]) > es-button:focus, :host([dropdown-item]) > es-button-link:focus {
            outline: none;
            --background-color: var(--color-shade-30);
            --foreground-color: var(--color-secondary);
        }
